import React from 'react';
import { Typography } from '@mui/material';

const BlockHeader = ({ text, fontSize }: { text: string; fontSize?: string }) => {
    return (
        <Typography
            sx={{
                color: '#0F0E0E',
                fontFamily: 'AvenirNext700',
                fontSize: fontSize ? fontSize : '32px',
            }}
        >
            {text}
        </Typography>
    );
};
export default BlockHeader;
